import { Outlet } from 'react-router-dom';
import styled from '@emotion/styled';
import { Aside } from 'shared/ui/Aside/Aside';
import { Header } from 'shared/ui/Header/Header';
import { useAppSelector } from 'app/store';

export const StyledDashboardlayout = styled('div')(
  () => `
  display: flex;
  justify-content: flex-end;
  background: #F4F4F4;

  main {
    width: calc(100% - 300px);
    padding: 125px 20px 35px 40px;
  }
`,
);

export const DashboardLayout = () => {
  const { actionBtn } = useAppSelector((state) => state.ui);

  return (
    <StyledDashboardlayout>
      <Aside />
      <main>
        {actionBtn !== 'custom' && <Header />}
        <Outlet />
      </main>
    </StyledDashboardlayout>
  );
};
